<template>
  <v-container>
    <v-row>
      <v-col cols="10">
        <p class="person-index ml-1"> {{ $t('insurancesStep.insuranceAcc') }}</p>
      </v-col>
      <v-col cols="2">
        <v-btn icon color="primary" @click="removeAssurance()">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-text-field
      v-if="!readonly"
      v-model="name"
      :label="$t('insurance.name')"
      filled
      class="required"
      :rules="[rules.required]">
    </v-text-field>
    <v-menu
        ref="menuDate"
        v-model="menuDate"
        :return-value.sync="formattedAccidentDate"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            ref="dateField"
            v-model="formattedAccidentDate"
            :label="$t('insurance.accidentDate')"
            prepend-icon="mdi-calendar"
            readonly
            filled
            v-bind="attrs"
            v-on="on" />
      </template>
      <v-date-picker
          v-model="accidentDate"
          :active-picker.sync="activeAccidentDatePicker"
          min="2020-01-01"
          locale="fr-CH"
          :first-day-of-week="1"
          @blur="date = doParseDate(dateFormatted)"
          @change="saveAccidentDate">
      </v-date-picker>
    </v-menu>
    <v-text-field
        v-if="!readonly"
        v-model="accidentNumber"
        :label="$t('insurance.accidentNumber')"
        filled>
    </v-text-field>
  </v-container>
</template>
<script>
import { requiredRule } from '@/helpers/validationRules';
import {formatDate, parseDate} from "@/helpers/dates";

export default {
  data() {
    return {
      name: this.insurance.name,
      accidentDate: this.insurance.accidentDate,
      accidentNumber: this.insurance.accidentNumber,
      rules: {
        required: requiredRule
      },
      menuDate: false,
      activeAccidentDatePicker: null,
    };
  },
  props: {
    insurance: { type: Object, required: true },
    readonly: { type: Boolean, required: false }
  },
  computed: {
    updateData() {
      const { name, accidentDate, accidentNumber } = this;
      return { name, accidentDate, accidentNumber };
    },
    formattedAccidentDate: {
      get() {
        return formatDate(this.accidentDate);
      },
      set() {}
    },
  },
  watch: {
    updateData: {
      handler() {
        this.$emit('input', {
          name: this.name,
          accidentDate: this.accidentDate,
          accidentNumber: this.accidentNumber,
        });
      },
      deep: true
    }
  },
  methods: {
    removeAssurance() {
      this.$emit('removeInsurance');
    },
    doParseDate(date) {
      return parseDate(date);
    },
    saveAccidentDate(date) {
      this.$refs.menuDate.save(date);
    },
  }
};
</script>
